import { render, staticRenderFns } from "./CompanyDetail.vue?vue&type=template&id=17282ff5&"
import script from "../../../services/admin/company/company-detail.js?vue&type=script&lang=js&"
export * from "../../../services/admin/company/company-detail.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports